import { trpc, TRPCReactQueryOptions, TRPCRouterInputs } from '@sternum/web/services/trpc';

type GetDashboardsRequest = TRPCRouterInputs['dashboard']['getDashboards'];
type UseDashboardsOptions = TRPCReactQueryOptions['dashboard']['getDashboards'];

const emptyArray: never[] = [];

export function useDashboards(request: GetDashboardsRequest, options: UseDashboardsOptions = {}) {
  const { data, ...rest } = trpc.dashboard.getDashboards.useQuery(request, {
    staleTime: Infinity,
    ...options,
  });

  const dashboards = data?.dashboards || emptyArray;

  return { dashboards, ...rest };
}
